const fetchPermissions = () => ({
  artwork: 0,
  pizzas: 0,
  pricePanel: 1,
  ratingSystem: 1,
  ticketSystem: 0,
});

export default fetchPermissions();
